import { useSelector } from 'react-redux';
import { userSelector } from 'redux/auth/selectors';
import { userRole } from 'utils/userRole';

export const useUserRole = () => {
  const user = useSelector(userSelector);
  return userRole(user);
};
